import React from 'react';
import {
  AppBar, Toolbar, Typography, Button, Container, Box,
  IconButton, Tooltip
} from '@mui/material';
import {
  Facebook,
  MusicNote,
  Instagram,
  WhatsApp
} from '@mui/icons-material';
import { Link } from 'react-router-dom';

const Layout = ({ children }) => {
  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          bgcolor: 'rgba(26, 35, 126, 0.98)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
        }}
      >
        <Toolbar>
          <Typography
            variant="h6"
            component={Link}
            to="/"
            sx={{
              flexGrow: 1,
              color: 'white',
              textDecoration: 'none',
              fontWeight: 800,
              letterSpacing: '0.5px',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              fontSize: { xs: '1rem', md: '1.25rem' }
            }}
          >
            🏠 Barkon Luxury Guesthouse
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Button
              color="inherit"
              component={Link}
              to="/"
              sx={{ color: 'white', textTransform: 'none', fontWeight: 600, display: { xs: 'none', sm: 'flex' } }}
            >
              Home
            </Button>
            <Button
              color="inherit"
              component={Link}
              to="/my-bookings"
              sx={{ color: 'white', textTransform: 'none', fontWeight: 600, fontSize: { xs: '0.75rem', md: '0.875rem' } }}
            >
              My Bookings
            </Button>

            <Tooltip title="Facebook">
              <IconButton color="inherit" component={Link} to="/facebook" sx={{ color: 'white', display: { xs: 'none', sm: 'flex' } }}>
                <Facebook />
              </IconButton>
            </Tooltip>
            <Tooltip title="TikTok">
              <IconButton color="inherit" component={Link} to="/tiktok" sx={{ color: 'white', display: { xs: 'none', sm: 'flex' } }}>
                <MusicNote />
              </IconButton>
            </Tooltip>
            <Tooltip title="Instagram">
              <IconButton
                color="inherit"
                component="a"
                href="https://instagram.com/barkonguesthouse"
                target="_blank"
                sx={{ color: 'white', display: { xs: 'none', sm: 'flex' } }}
              >
                <Instagram />
              </IconButton>
            </Tooltip>
            <Tooltip title="WhatsApp">
              <IconButton
                color="inherit"
                component="a"
                href="https://wa.me/251911524667"
                target="_blank"
                sx={{ color: 'white' }}
              >
                <WhatsApp />
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </AppBar>

      <Container maxWidth="xl" sx={{ mt: 0, mb: 0, p: 0 }}>
        {children}
      </Container>
    </>
  );
};

export default Layout;